exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table__footer .cell {\n  text-align: right;\n}\n.synthese-gestion .el-table__body-wrapper {\n  overflow-x: scroll !important;\n  z-index: 1;\n}\n", ""]);

// exports
